/**
 * NAD+ Energy Section
 * Handles intersection observer for animation triggers
 */

class NADEnergySection {
  private section: HTMLElement;
  private observer: IntersectionObserver | null = null;
  
  constructor(section: HTMLElement) {
    this.section = section;
    this.init();
  }
  
  private init(): void {
    this.setupIntersectionObserver();
  }
  
  private setupIntersectionObserver(): void {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.section.classList.add('nad-energy-section--visible');
          this.observer?.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2,
      rootMargin: '-10% 0px'
    });
    
    this.observer.observe(this.section);
  }

  public destroy(): void {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    this.section.classList.remove('nad-energy-section--visible');
  }

  public static initializeAll(): NADEnergySection[] {
    const sections = document.querySelectorAll<HTMLElement>('.nad-energy-section');
    return Array.from(sections).map(section => new NADEnergySection(section));
  }

  public static destroySection(section: HTMLElement): void {
    const instance = (section as any).__nadEnergySection;
    if (instance && instance.destroy) {
      instance.destroy();
    }
  }
}

// Export for initialization from main file
export { NADEnergySection };
